export enum UserDesignOperation {
  DRAW_SHAPE = 'drawShape',
  MODIFY_SHAPE_SIZE = 'modifyShapeSize',
  MODIFY_SHAPE_NAME = 'modifyShapeName',
  MODIFY_SIDE_TYPE_WALL_SIDE = 'modifySideTypeWallSide',
  MODIFY_SIDE_TYPE_APPLIANCE_SIDE = 'modifySideTypeApplianceSide',
  MODIFY_SIDE_TYPE_WATERFALL_PANEL = 'modifySideTypeWaterfallPanel',
  MODIFY_BACKSPLASH_WALL_SIDE = 'modifyBacksplashWallSide',
  MODIFY_BACKSPLASH_HEIGHT = 'modifyBacksplashHeight',
  MODIFY_WATERFALL_PANEL_HEIGHT = 'modifyWaterfallPanelHeight',
  MODIFY_COLOR = 'modifyColor',
  MODIFY_EDGE = 'modifyEdge',
  MODIFY_CORNER_RADIUS = 'modifyCornerRadius',
  MODIFY_INSIDE_DIAGONAL_CORNER = 'modifyInsideDiagonalCorner',
  MODIFY_OUTSIDE_DIAGONAL_CORNER = 'modifyOutsideDiagonalCorner',
  REMOVE_DIAGONAL_CORNER = 'removeDiagonalCorner',
  MODIFY_RADIUS_OUT = 'modifyRadiusOut',
  MODIFY_BUMP_OUT = 'modifyBumpOut',
  REMOVE_CUSTOM_SIDE = 'removeCustomSide',
  MODIFY_SINK = 'modifySink',
  MODIFY_COOKTOP = 'modifyCooktop',
  MODIFY_RANGE = 'modifyRange',
  MODIFY_FAUCET = 'modifyFaucet',
  MODIFY_ELECTRICAL_CUTOUT = 'modifyElectricalCutout',
  MOVE_APPLIANCE = 'moveDraggableItem',
  MOVE_SHAPE = 'moveShape',
  REMOVE_SHAPE = 'removeShape',
  REMOVE_APPLIANCE = 'removeAppliance',
  REMOVE_ALL_SINKS = 'removeAllSinks',
  ROTATE_CLOCKWISE = 'rotateClockwise',
  ROTATE_COUNTERCLOCKWISE = 'rotateCounterClockwise',
  DUPLICATE_SHAPE = 'duplicateShape',
  UNDO = 'undo',
  REDO = 'redo',
}
